import React from 'react';
import { Table, TableBody, TableRow, TableCell } from '@material-ui/core';

import formatters from '../../../../formatters';

function VaultInfo(props) {
    const { currentVault } = props;

    return (
        <Table>
            <TableBody>
                <TableRow>
                    <TableCell>Recipients</TableCell>
                    <TableCell align="right">
                        {currentVault?.recipient_count}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Last updated</TableCell>
                    <TableCell align="right">
                        {formatters.date(currentVault?.last_modified_date)}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Owners</TableCell>
                    <TableCell align="right">{currentVault?.owners}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
}
export default VaultInfo;
